import { render, staticRenderFns } from "./resizable-table.vue?vue&type=template&id=eda9339e&"
import script from "./resizable-table.vue?vue&type=script&lang=js&"
export * from "./resizable-table.vue?vue&type=script&lang=js&"
import style0 from "./resizable-table.vue?vue&type=style&index=0&id=eda9339e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports